// Die fünf Rollen, die ein Kontakt FÜR ANDERE ausübt (Anforderungs-Excel,
// Spalte „Vertretung / Bevollmächtigter eines Kontaktes“).
//
// WARUM BEZIEHUNG UND NICHT FELD: Jede dieser Rollen hat zwingend ein
// Gegenüber. Als Feld am Kontakt wäre sie ein Freitext, der bei jeder
// Umbenennung veraltet, in der Akte des Vertretenen gar nicht auftaucht und
// sich nicht auswerten lässt.
//
// WARUM KEIN ZWEITES VOKABULAR: Gespeichert wird in `ContactRelation` mit
// einem Typ aus `ContactRelationType` — dem vorhandenen Beziehungs-Vokabular.
// Die fünf Rollen sind fünf weitere Katalogzeilen (Migration 202608190003 +
// `ContactRelationTypeSeedService`), keine eigene Tabelle. Die
// Rechtsform-×-Rollen-Matrix ist nicht der richtige Ort: Sie beantwortet
// „welches Amt darf es bei einer GmbH geben“ — ein Vormund gehört zu keiner
// Rechtsform.
//
// RICHTUNGSKONVENTION (siehe `ContactRelation.reverseRelationType`):
// `relationType` beschreibt, was `contactDest` FÜR `contactSrc` ist. „A ist
// Betreuer von B“ wird deshalb als Zeile `contactSrc = B`, `contactDest = A`,
// `relationType = 'Betreuer'`, `reverseRelationType = 'Betreuter'` gespeichert.
// In Bs Akte steht damit „Betreuer: A“, in As Akte „Betreuter: B“.
//
// Die Gegenbezeichnungen sind die stehenden Rechtsbegriffe: Vollmachtgeber
// (§ 167 BGB), Erblasser (§ 2197 BGB), Betreuter (§ 1814 BGB), Mündel
// (§ 1773 BGB), Pflegebefohlener (§ 1809 BGB).
//
// `rolle` ist der Speicherwert und MUSS zeichengleich zu
// `apps/api/src/data/vertretungsrollen.ts` bleiben.

export type Vertretungsrolle = {
  /** Was der Kontakt FÜR den anderen ist — Speicherwert (`relationType`). */
  rolle: string;
  /** Was der andere für den Kontakt ist (`reverseRelationType`). */
  gegenrolle: string;
  /** Beschriftung in der Liste „Dieser Kontakt vertritt“. */
  label: string;
};

export const VERTRETUNGSROLLEN: readonly Vertretungsrolle[] = [
  { rolle: "Vorsorgebevollmächtigter", gegenrolle: "Vollmachtgeber", label: "Vorsorgebevollmächtigter für" },
  { rolle: "Testamentsvollstrecker", gegenrolle: "Erblasser", label: "Testamentsvollstrecker für" },
  { rolle: "Betreuer", gegenrolle: "Betreuter", label: "Betreuer von" },
  { rolle: "Vormund", gegenrolle: "Mündel", label: "Vormund von" },
  { rolle: "Pfleger", gegenrolle: "Pflegebefohlener", label: "Pfleger für" },
] as const;

const NACH_ROLLE = new Map(VERTRETUNGSROLLEN.map((r) => [r.rolle, r]));

/** Ist dieser gespeicherte Beziehungstyp eine der fünf Vertretungsrollen? */
export const istVertretungsrolle = (relationType: string | null | undefined): boolean =>
  !!relationType && NACH_ROLLE.has(relationType.trim());

/** Beschriftung („Betreuer von“) zu einem gespeicherten Beziehungstyp. */
export const vertretungsrolleLabel = (relationType: string): string =>
  NACH_ROLLE.get(relationType.trim())?.label ?? relationType;

/** Gegenrichtung zu einem gespeicherten Beziehungstyp, sonst `null`. */
export const vertretungsGegenrolle = (relationType: string): string | null =>
  NACH_ROLLE.get(relationType.trim())?.gegenrolle ?? null;
